{
  "bookButtonLabel": "अभी अपॉइंटमेंट बुक करें",
  "bookText": "<h3>ऑनलाइन बुक करें:</h3>\n<ul>\n  <li>⏱️  <strong>तेज़ और आसान -</strong> 15 मिनट या कम</li>\n  <li>🌙  <strong>कभी भी बुक करें -</strong> कामकाजी समय के बाद भी</li>\n  <li>🗓️  <strong>अपने अनुसार समय चुनें</strong></li>\n  <li>🔐  <strong>कोई कागजी काम नहीं -</strong> सुरक्षित और सटीक</li>\n</ul>",
  "declineButtonLabel": "इस बुकिंग निमंत्रण को अस्वीकार करें",
  "declineText": "<h3>क्या आप इस प्रक्रिया की उम्मीद नहीं कर रहे थे या इसे नहीं चाहते?</h3>\n<p>कृपया कारण चुनकर हमें बताएं:</p>",
  "helpMessage": "<h3>क्या आप किसी से बात करना पसंद करेंगे?</h3>\n<p>हमारी सहायक टीम आपकी मदद के लिए तैयार है:<br/><a><strong>☎️ {{phone}}</strong></a> (फिर <strong>विकल्प 2</strong> दबाएं)<br/>सोमवार से शुक्रवार, सुबह 8 से शाम 5 बजे तक।</p>\n<p><em>हमारी टीम केवल अंग्रेज़ी बोल सकती है — आपकी समझदारी के लिए धन्यवाद।</em></p>",
  "info": "<h3>क्या आप इस प्रक्रिया के बारे में और जानना चाहते हैं?</h3>\n<p>एक छोटा सा वीडियो देखें जो बताता है कि क्या अपेक्षा करें और कैसे तैयारी करें।</p>",
  "select": {
    "badTiming": "समय सुविधाजनक नहीं है",
    "cantAfford": "अभी खर्च नहीं उठा सकता/सकती",
    "didntKnowReferred": "मुझे नहीं पता था कि मेरा रेफ़रल किया गया है",
    "hadElsewhere": "मैं यह पहले ही कहीं और करवा चुका/चुकी हूँ",
    "notNecessary": "मुझे नहीं लगता कि यह ज़रूरी है",
    "placeholder": "एक कारण चुनें"
  },
  "text": "<p>आपके जीपी <strong>{{requestingPractitioner.displayName}}</strong> ने आपको <strong>{{practitioners.0.name}}</strong> के साथ <strong>{{procedure.displayName}}</strong> के लिए रेफर किया है।</p>",
  "textNoSpecialist": "<p>आपके जीपी <strong>{{requestingPractitioner.displayName}}</strong> ने आपको <strong>{{procedure.displayName}}</strong> के लिए रेफर किया है।</p>",
  "title": "नमस्ते {{patient.nameGiven}}।<br /> अब आपकी प्रक्रिया की बुकिंग का समय है।",
  "videoButtonLabel": "एंडोस्कोपी प्रक्रिया के बारे में वीडियो चलाएं",
  "videoCaption": "हम अनुशंसा करते हैं कि बुकिंग से पहले इस वीडियो को देखें।",
  "videos": {
    "fallback": "xOJ9ZzI4ZMJesGEHEhogTu1uavfbneC6m5Xuf5HDrCo",
    "gas": "xOJ9ZzI4ZMJesGEHEhogTu1uavfbneC6m5Xuf5HDrCo"
  }
}
